/* tslint:disable */
/* eslint-disable */
/**
 * SISCC Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigurationFileUrls
 */
export interface ConfigurationFileUrls {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationFileUrls
     */
    readonly stylingFile: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationFileUrls
     */
    readonly summaryFile: string;
}

export function ConfigurationFileUrlsFromJSON(json: any): ConfigurationFileUrls {
    return ConfigurationFileUrlsFromJSONTyped(json, false);
}

export function ConfigurationFileUrlsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationFileUrls {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stylingFile': json['stylingFile'],
        'summaryFile': json['summaryFile'],
    };
}

export function ConfigurationFileUrlsToJSON(value?: ConfigurationFileUrls | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


